import MeetOurTeamStyle from '@/styles/components/careers/add-section/_index.module.scss';

export function MeetTeamSection({formik, sidebar_section, customizeCareerAction}){
  return(
    <div className = {`${MeetOurTeamStyle.MeetTeam}`}>
      <label className = {`${MeetOurTeamStyle.MeetTeam__Title}`}>Meet Our Team</label>
      {/************* First Option ***************/}
      <div className = {`${MeetOurTeamStyle.MeetTeam__FirstOption}`} onClick={(event) => {
            customizeCareerAction.addSection(formik, 'team', 'with_description')
          }}>
        <div className = {`${MeetOurTeamStyle.MeetTeam__Content}`}>
            <div className = {`${MeetOurTeamStyle.MeetTeam__SubTitle}`}>
              <h3>Meet Our Team</h3>
            </div>
            <div className = {`${MeetOurTeamStyle.MeetTeam__Cards}`}>
              <div className = {`${MeetOurTeamStyle.MeetTeam__Card}`}>
                <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Top}`}>
                <div className = {`${MeetOurTeamStyle.MeetTeam__Card__UserDetails}`}>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Icon}`}>
                      <img src = '/images/pages/career/meet_our_team/member1.png'></img>
                    </div>
                  </div>
                  <div className = {`${MeetOurTeamStyle.MeetTeam__RightContent}`}>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom__Name}`}>
                      <label>John Clark</label>
                    </div>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom__Designation}`}>
                      <label>CEO, Founder</label>
                    </div>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Text}`}>
                      <p>Arsenal is a real family. I would encourage anyone to come and work here. It’s a club that’s true to it’s traditions. The calibre of people here is second to none.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className = {`${MeetOurTeamStyle.MeetTeam__Card}`}>
                <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Top}`}>
                  <div className = {`${MeetOurTeamStyle.MeetTeam__Card__UserDetails}`}>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Icon}`}>
                      <img src = '/images/pages/career/meet_our_team/member2.png'></img>
                    </div>
                  </div>

                  <div className = {`${MeetOurTeamStyle.MeetTeam__RightContent}`}>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom__Name}`}>
                      <label>Emily Wilson</label>
                    </div>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom__Designation}`}>
                      <label>Founder</label>
                    </div>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Text}`}>
                      <p>We aim to be innovative in all we do. We can’t achieve anything if we don’t work together as a team. Everything we do is has our supporters at the centre of our focus – to provide fans with the best experience with the Club as possible.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className = {`${MeetOurTeamStyle.MeetTeam__Card}`}>
                <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Top}`}>
                  <div className = {`${MeetOurTeamStyle.MeetTeam__Card__UserDetails}`}>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Icon}`}>
                      <img src = '/images/pages/career/meet_our_team/member3.png'></img>
                    </div>
                  </div>
                  <div className = {`${MeetOurTeamStyle.MeetTeam__RightContent}`}>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom__Name}`}>
                      <label>John Smith</label>
                    </div>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom__Designation}`}>
                      <label>Product</label>
                    </div>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Text}`}>
                      <p>We aim to be innovative in all we do. We can’t achieve anything if we don’t work together as a team. Everything we do is has our supporters at the centre of our focus – to provide fans with the best experience with the Club as possible.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className = {`${MeetOurTeamStyle.MeetTeam__Card}`}>
                <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Top}`}>
                  <div className = {`${MeetOurTeamStyle.MeetTeam__Card__UserDetails}`}>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Icon}`}>
                      <img src = '/images/pages/career/meet_our_team/member4.png'></img>
                    </div>
                  </div>
                  <div className = {`${MeetOurTeamStyle.MeetTeam__RightContent}`}>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom__Name}`}>
                      <label>Lisa Brown</label>
                    </div>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom__Designation}`}>
                      <label>Product</label>
                    </div>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Text}`}>
                      <p>Arsenal champion internal progression and organic growth. Hard work gets rewarded and employee training/development is endorsed across the club. I have always felt trusted to manage my own schedule but supported when in need of help. It’s also extremely fun, social and exciting to work for a football club</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className = {`${MeetOurTeamStyle.MeetTeam__Card}`}>
                <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Top}`}>
                  <div className = {`${MeetOurTeamStyle.MeetTeam__Card__UserDetails}`}>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Icon}`}>
                      <img src = '/images/pages/career/meet_our_team/member5.png'></img>
                    </div>
                  </div>
                  <div className = {`${MeetOurTeamStyle.MeetTeam__RightContent}`}>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom__Name}`}>
                      <label>James White</label>
                    </div>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom__Designation}`}>
                      <label>Marketing</label>
                    </div>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Text}`}>
                      <p>We aim to be innovative in all we do. We can’t achieve anything if we don’t work together as a team. Everything we do is has our supporters at the centre of our focus – to provide fans with the best experience with the Club as possible.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className = {`${MeetOurTeamStyle.MeetTeam__Card}`}>
                <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Top}`}>
                  <div className = {`${MeetOurTeamStyle.MeetTeam__Card__UserDetails}`}>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Icon}`}>
                      <img src = '/images/pages/career/meet_our_team/member6.png'></img>
                    </div>
                  </div>
                  <div className = {`${MeetOurTeamStyle.MeetTeam__RightContent}`}>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom__Name}`}>
                      <label>Laura Johnson</label>
                    </div>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom__Designation}`}>
                      <label>Product</label>
                    </div>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Text}`}>
                      <p>Arsenal is a real family. I would encourage anyone to come and work here. It’s a club that’s true to it’s traditions. The calibre of people here is second to none.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
        <div className = {`${MeetOurTeamStyle.MeetTeam__AddBtn} noAddbtn__Inreorder`}>
          <span>Add</span>
        </div>
      </div>

      {/************* Second Option ***************/}
      <div className = {`${MeetOurTeamStyle.MeetTeam__SecondOption}`} onClick={(event) => {
            customizeCareerAction.addSection(formik, 'team', 'without_description')
          }}>
        <div className = {`${MeetOurTeamStyle.MeetTeam__Content}`}>
            <div className = {`${MeetOurTeamStyle.MeetTeam__SubTitle}`}>
              <h3>Meet Our Team</h3>
            </div>
            <div className = {`${MeetOurTeamStyle.MeetTeam__Cards}`}>
              <div className = {`${MeetOurTeamStyle.MeetTeam__Card} ${MeetOurTeamStyle.MeetTeam__SecondOption__Card}`}>
                <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Top}`}>
                  <div className = {`${MeetOurTeamStyle.MeetTeam__Card__UserDetails} ${MeetOurTeamStyle.MeetTeam__MarginAuto}`}>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Icon}`}>
                      <img src = '/images/pages/career/meet_our_team/member1.png'></img>
                    </div>
                  </div>
                </div>
                <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom} ${MeetOurTeamStyle.MeetTeam__Card__TextCenter}`}>
                  <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom__Name}`}>
                      <label>John Clark</label>
                    </div>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom__Designation}`}>
                      <label>CEO, Manafon</label>
                    </div>
                </div>
              </div>
              <div className = {`${MeetOurTeamStyle.MeetTeam__Card} ${MeetOurTeamStyle.MeetTeam__SecondOption__Card}`}>
                <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Top}`}>
                  <div className = {`${MeetOurTeamStyle.MeetTeam__Card__UserDetails} ${MeetOurTeamStyle.MeetTeam__MarginAuto}`}>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Icon}`}>
                      <img src = '/images/pages/career/meet_our_team/member2.png'></img>
                    </div>
                  </div>
                </div>
                <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom} ${MeetOurTeamStyle.MeetTeam__Card__TextCenter}`}>
                  <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom__Name}`}>
                      <label>Emily Wilson</label>
                    </div>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom__Designation}`}>
                      <label>CEO, Manafon</label>
                    </div>
                </div>
              </div>
              <div className = {`${MeetOurTeamStyle.MeetTeam__Card} ${MeetOurTeamStyle.MeetTeam__SecondOption__Card}`}>
                <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Top}`}>
                  <div className = {`${MeetOurTeamStyle.MeetTeam__Card__UserDetails} ${MeetOurTeamStyle.MeetTeam__MarginAuto}`}>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Icon}`}>
                      <img src = '/images/pages/career/meet_our_team/member3.png'></img>
                    </div>
                  </div>
                </div>
                <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom} ${MeetOurTeamStyle.MeetTeam__Card__TextCenter}`}>
                  <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom__Name}`}>
                      <label>John Smith</label>
                    </div>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom__Designation}`}>
                      <label>CEO, Manafon</label>
                    </div>
                </div>
              </div>
              <div className = {`${MeetOurTeamStyle.MeetTeam__Card} ${MeetOurTeamStyle.MeetTeam__SecondOption__Card}`}>
                <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Top}`}>
                  <div className = {`${MeetOurTeamStyle.MeetTeam__Card__UserDetails} ${MeetOurTeamStyle.MeetTeam__MarginAuto}`}>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Icon}`}>
                      <img src = '/images/pages/career/meet_our_team/member4.png'></img>
                    </div>
                  </div>
                </div>
                <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom} ${MeetOurTeamStyle.MeetTeam__Card__TextCenter}`}>
                  <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom__Name}`}>
                      <label>Lisa Brown</label>
                    </div>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom__Designation}`}>
                      <label>CEO, Manafon</label>
                    </div>
                </div>
              </div>
              <div className = {`${MeetOurTeamStyle.MeetTeam__Card} ${MeetOurTeamStyle.MeetTeam__SecondOption__Card}`}>
                <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Top}`}>
                  <div className = {`${MeetOurTeamStyle.MeetTeam__Card__UserDetails} ${MeetOurTeamStyle.MeetTeam__MarginAuto}`}>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Icon}`}>
                      <img src = '/images/pages/career/meet_our_team/member5.png'></img>
                    </div>
                  </div>
                </div>
                <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom} ${MeetOurTeamStyle.MeetTeam__Card__TextCenter}`}>
                  <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom__Name}`}>
                      <label>James White</label>
                    </div>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom__Designation}`}>
                      <label>CEO, Manafon</label>
                    </div>
                </div>
              </div>
              <div className = {`${MeetOurTeamStyle.MeetTeam__Card} ${MeetOurTeamStyle.MeetTeam__SecondOption__Card}`}>
                <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Top}`}>
                  <div className = {`${MeetOurTeamStyle.MeetTeam__Card__UserDetails} ${MeetOurTeamStyle.MeetTeam__MarginAuto}`}>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Icon}`}>
                      <img src = '/images/pages/career/meet_our_team/member6.png'></img>
                    </div>
                  </div>
                </div>
                <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom} ${MeetOurTeamStyle.MeetTeam__Card__TextCenter}`}>
                  <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom__Name}`}>
                      <label>Laura Johnson</label>
                    </div>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom__Designation}`}>
                      <label>CEO, Manafon</label>
                    </div>
                </div>
              </div>
            </div>
        </div>
        <div className = {`${MeetOurTeamStyle.MeetTeam__AddBtn} noAddbtn__Inreorder`}>
          <span>Add</span>
        </div>
      </div>
    </div>
  )
}